import React, { Component } from 'react';
import { routes } from 'constants/config';
import { Button } from 'ui';
import request from 'utils/request_ajax';
import { hasFeatureFlags } from 'utils/features';
import { setParamsFromObject } from 'utils/url';

class GradePendingNotice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: true,
    };

    this.hasMounted = false;
  }

  enabledMultipleReviewers = hasFeatureFlags([
    'readiness-enable-multiple-reviewers',
  ]);

  fetchPendingCount = () => {
    request.get(routes.GRADES.DISPLAY_GRADES_PENDING).then(gradeData => {
      if (this.hasMounted) {
        this.setState({ data: gradeData, loading: false });
      }
    });
  };

  componentDidMount() {
    this.hasMounted = true;
    this.fetchPendingCount();
    global.pubsub.subscribe(
      'grades:update_pending_count',
      this.fetchPendingCount,
    );
  }

  componentWillUnmount() {
    this.hasMounted = false;
    global.pubsub.unsubscribe(
      'grades:update_pending_count',
      this.fetchPendingCount,
    );
  }

  getUrl = () => {
    if (
      this.enabledMultipleReviewers &&
      this.state.data.learner_grade_pending_count === 0 &&
      this.state.data.additional_reviews_pending === true
    ) {
      return setParamsFromObject(routes.GRADES.INDEX(), {
        tabName: 'AvailableReviewLessons',
      });
    }
    return routes.GRADES.INDEX();
  };

  displayGradePendingCount = () => {
    const gradePendingCount = this.state.data.learner_grade_pending_count;

    if (this.state.data.over_limit) {
      return (
        <span className="GradePendingNotice-badge">{gradePendingCount}+</span>
      );
    }
    return (
      <span className="GradePendingNotice-badge">{gradePendingCount}</span>
    );
  };

  render() {
    const { loading, data } = this.state;

    if (
      loading ||
      (!this.enabledMultipleReviewers &&
        data.learner_grade_pending_count === 0) ||
      (this.enabledMultipleReviewers &&
        data.learner_grade_pending_count === 0 &&
        data.additional_reviews_pending === false)
    )
      return null;

    return (
      <li className="ml-4 mr-4">
        <Button
          className="GradePendingNotice trk_button_learning_items-to-grade"
          onClick={() => {
            window.location.href = this.getUrl();
          }}
        >
          <>
            {data.learner_grade_pending_count > 0 && (
              <span className="d-f ai-c fz-14 lh-14">
                {this.displayGradePendingCount()}
                {t('grades.items_to_grade_label', {
                  count: this.state.data.learner_grade_pending_count,
                })}
              </span>
            )}
            {data.learner_grade_pending_count === 0 &&
              this.enabledMultipleReviewers &&
              data.additional_reviews_pending === true && (
                <span className="d-f ai-c fz-14 lh-14">
                  {t('grades.items_to_review_label')}
                </span>
              )}
          </>
        </Button>
      </li>
    );
  }
}

export default GradePendingNotice;
